import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'lib-form-points-division',
  templateUrl: './form-points-division.component.html',
  styleUrls: ['./form-points-division.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormPointsDivisionComponent implements OnInit {
  @Input() form: FormGroup = this.getDefaultForm();
  @Input() pointsToDivide = 100;
  @Input() labels: string[] = [];
  @Input() autoCorrect = false;
  @Input() withTransloco = false; /* TODO: remove after refactor to full transloco */
  /* instead of setting errors on particular control we emit event, so none of control is red */
  @Output() formValidationEmitter = new EventEmitter<boolean>();

  constructor() {}
  max!: number;
  pointsLeft!: number;
  divisionControlArr;
  ngOnInit() {
    this.divisionControlArr = Object.entries(this.form.controls);
    this.max = this.pointsLeft = this.pointsToDivide;
    this.pointsLeft = this.setPointsLeft();
  }

  setPointsLeft() {
    let allPointsSpent = 0;
    for (const control in this.form.controls) {
      const element = this.form.controls[control];
      allPointsSpent += element.value;
    }
    return this.max - allPointsSpent;
  }

  handleValueChange(control: FormControl) {
    if (this.autoCorrect) {
      if (control.value === null || control.value < 0) {
        control.setValue(0);
      }
      this.pointsLeft = this.setPointsLeft();
      if (0 >= this.pointsLeft) {
        control.setValue(Number.parseInt(control.value) + this.pointsLeft);
        this.pointsLeft = 0;
      }
    } else {
      this.pointsLeft = this.setPointsLeft();
    }

    this.formValidationEmitter.emit(this.pointsLeft !== 0);
  }

  handleInputClick(control: FormControl) {
    if (control.value === 0) {
      control.setValue('');
    }
  }

  handleInputBlur(control: FormControl) {
    if (control.value === '') {
      control.setValue(0);
    }
  }

  getDefaultForm() {
    /* for mock */
    return new FormGroup({ first: new FormControl(0), second: new FormControl(0), third: new FormControl(0) });
  }
}
